import Peer from 'skyway-js';
import { CHELSkywayPlayer } from './CHELSkyPlayer';
import { HEL_AUDIO_TYPE_VOICE, SKYWAY_API_HOST, worldViewerWindow } from './const';
import { debugLog } from './debugLog';
import { getLocalStream, getMixerSettingAt, getPeer, getSkyRoomId, getSkywayKey, getSkywayName, getSkywayOnScreenShareStarted, getSkywayPlayerList, setLocalStream, setPeer, setSkyRoomId, setSkywayAvatarNumber, setSkywayAvatarNumberForSend, setSkywayName, setSkywayPlayerList, setSkywayRoom } from './logics/dataOps';
import { requestSendingReceivedPacketsFromSkyway } from './logics/moduleCaller';
/**
 * heliodor_skyway_rcpから参照があるためglobal関数
 * @param peerId
 */ worldViewerWindow.hel_skyway_create_player = (peerId)=>{
    const skywayPlayer = new CHELSkywayPlayer(peerId, getMixerSettingAt(HEL_AUDIO_TYPE_VOICE));
    const skywayPlayerList = getSkywayPlayerList();
    //	debugLog("hel_skyway_create_player " + peerId);
    for(let n = 0; n < skywayPlayerList.length; n++){
        if (skywayPlayerList[n] === null) {
            setSkywayPlayerList(skywayPlayer, n);
            return skywayPlayer;
        }
    }
    skywayPlayerList.push(skywayPlayer);
    return skywayPlayer;
};
/**
 * heliodor_skyway_xrw, heliodor_skyway_rcpから参照があるためglobal関数
 * @param peerId
 */ worldViewerWindow.hel_skyway_release_player = (peerId)=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer === null) {
            continue;
        }
        if (skywayPlayer.getPeerId() === peerId) {
            skywayPlayer.release();
            setSkywayPlayerList(null, n);
            return;
        }
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrw, heliodor_xrw_mainから参照があるためglobal関数
 * @param peerId
 */ worldViewerWindow.hel_skyway_get_player = (peerId)=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer == null) {
            continue;
        }
        if (skywayPlayer.getPeerId() === peerId) {
            return skywayPlayer;
        }
    }
    return null;
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param stream
 */ worldViewerWindow.hel_skyway_stream = (stream)=>{
    if (!stream.peerId) {
        debugLog('stream.peerId not');
        return;
    }
    let player = worldViewerWindow.hel_skyway_get_player(stream.peerId);
    if (player == null) {
        player = worldViewerWindow.hel_skyway_create_player(stream.peerId);
        if (player == null) {
            debugLog('hel_skyway_get_player not ' + stream.peerId);
            return;
        }
    }
    player.setStream(stream);
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param volume
 */ worldViewerWindow.hel_skyway_SetMixerVolume = (volume)=>{
    const skywayPlayerList = getSkywayPlayerList();
    for(let n = 0; n < skywayPlayerList.length; n++){
        const skywayPlayer = skywayPlayerList[n];
        if (skywayPlayer == null) {
            continue;
        }
        skywayPlayer.setVolume(volume);
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param roomid
 */ worldViewerWindow.hel_skyway_set_roomid = (roomid)=>setSkyRoomId(roomid)
;
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 */ worldViewerWindow.hel_skyway_get_roomid = ()=>getSkyRoomId()
;
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 */ worldViewerWindow.hel_skyway_set_avatar_from_cookie = ()=>{
    const avatar = worldViewerWindow.hel_get_cookie('Avatar');
    if (avatar !== undefined) {
        setSkywayAvatarNumber(avatar);
        setSkywayAvatarNumberForSend(avatar);
    }
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param cmd
 * @param id
 * @param param
 */ worldViewerWindow.hel_skyway_receive_data = (cmd, id, param)=>{
    const data = cmd + ':' + id + ':' + param;
    //	debugLog("receive_data / " + data);
    requestSendingReceivedPacketsFromSkyway(data);
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param id
 * @param text
 */ worldViewerWindow.hel_skyway_add_text_chat = (id, text)=>{
    worldViewerWindow.hel_skyway_receive_data('data', id, 'msg:' + text);
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @remarks
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param peerId
 * @param mute
 * @virtual
 */ worldViewerWindow.hel_skyway_SetVoiceMute = (peerId, mute)=>{
    const Player = worldViewerWindow.hel_skyway_get_player(peerId);
    if (Player == null) return;
    Player.SetMute(mute);
};
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrw, heliodor_xrw_mainから参照があるためglobal関数
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @virtual
 */ worldViewerWindow.hel_skyway_join = ()=>{
    //	const leaveTrigger = document.getElementById('js-leave-trigger');
    const remoteVideos = document.getElementById('js-remote-streams');
    // Note that you need to ensure the peer has connected to signaling server
    // before using methods of peer instance.
    const peer = getPeer();
    const localStream = getLocalStream();
    if (peer === undefined || localStream === undefined) {
        debugLog('worldViewerWindow.g_peer or worldViewerWindow.g_localStream is undefined');
        return;
    }
    if (!peer.open) {
        debugLog('hel_skyway_join : worldViewerWindow.g_peer not open');
        return;
    }
    //
    const parts = location.hostname.split('.');
    const subdomain = parts.shift();
    const skywayRoomId = subdomain + '_' + getSkyRoomId();
    //
    const room = peer.joinRoom(skywayRoomId, {
        mode: 'mesh',
        stream: localStream
    });
    setSkywayRoom(room);
    room.once('open', ()=>{
        //		worldViewerWindow.hel_skyway_add_text_chat("", 'You joined');
        worldViewerWindow.hel_skyway_receive_data('open', peer.id, '');
        // to set my name
        worldViewerWindow.hel_skyway_receive_data('data', peer.id, 'name:' + getSkywayName());
        // send my name to old player
        worldViewerWindow.hel_skyway_send_myinfo();
    });
    room.on('peerJoin', (peerId)=>{
        worldViewerWindow.hel_skyway_create_player(peerId);
        //		worldViewerWindow.hel_skyway_add_text_chat("", `${peerId} joined`);
        //		worldViewerWindow.hel_skyway_receive_data("join", peerId, "");
        // send my name to new player
        worldViewerWindow.hel_skyway_send_myinfo();
    });
    // Render remote stream for new peer join in the room
    room.on('stream', async (stream)=>{
        worldViewerWindow.hel_skyway_stream(stream);
        const newAudio = document.createElement('audio');
        newAudio.srcObject = stream;
        newAudio.playsInline = true;
        // mark peerId to find it later at peerLeave event
        newAudio.setAttribute('data-peer-id', stream.peerId);
        remoteVideos.append(newAudio);
        await newAudio.play().catch(console.error);
    });
    room.on('data', ({ data , src  })=>{
        // Show a message sent to the room and who sent
        //      messages.textContent += `${src}: ${data}\n`;
        //debugLog(`${src}: ${data}`);
        if (data === 'screenshare:shared') {
            const fn = getSkywayOnScreenShareStarted();
            if (fn !== undefined) {
                fn();
            }
        }
        worldViewerWindow.hel_skyway_receive_data('data', src, data);
    });
    // for closing room members
    room.on('peerLeave', (peerId)=>{
        worldViewerWindow.hel_skyway_release_player(peerId);
        const remoteVideo = remoteVideos.querySelector(`[data-peer-id="${peerId}"]`);
        remoteVideo.srcObject.getTracks().forEach((track)=>track.stop()
        );
        remoteVideo.srcObject = null;
        remoteVideo.remove();
        //      messages.textContent += `=== ${peerId} left ===\n`;
        //		worldViewerWindow.hel_skyway_add_text_chat("", `${peerId} leaved`);
        worldViewerWindow.hel_skyway_receive_data('leave', peerId, '');
    });
    // for closing myself
    room.once('close', ()=>{
        //      messages.textContent += '== You left ===\n';
        Array.from(remoteVideos.children).forEach((remoteVideo)=>{
            remoteVideo.srcObject.getTracks().forEach((track)=>track.stop()
            );
            remoteVideo.srcObject = null;
            remoteVideo.remove();
        });
    });
};
/**
 * @remarks
 * 呼出元でmediaDevicesがundefinedでないことを確認
 */ const setLocalAudioStreamBy = async ()=>{
    const localStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    }).catch(console.error);
    setLocalStream(localStream);
    return localStream;
};
/**
 * @remarks
 * Peerの初期化
 * @remarks
 * Peerの初期化を分離
 * @param configKey
 * @returns Peer|undefined
 */ worldViewerWindow.initializePeer = async (configKey)=>{
    const localVideo = document.getElementById('js-local-stream');
    // const remoteVideos = document.getElementById('js-remote-streams') as HTMLVideoElement;
    //
    // const sdkSrc = document.querySelector('script[src*=skyway]');
    if (!navigator.mediaDevices) {
        debugLog('navigator.mediaDevices not found');
        return undefined;
    }
    const localStream = await setLocalAudioStreamBy();
    // default mic mute
    worldViewerWindow.hel_skyway_set_mic_state(false);
    // Render local stream
    localVideo.muted = true;
    localVideo.srcObject = localStream;
    localVideo.playsInline = true;
    await localVideo.play().catch(console.error);
    const peer = new Peer({
        key: configKey === undefined ? getSkywayKey() : configKey,
        debug: 0
    });
    setPeer(peer);
    peer.on('error', console.error);
    return getPeer();
};
/**
 * @remarks
 * Peer経由でジョインする設定を実施
 */ worldViewerWindow.joinViaPeer = ()=>{
    const peer = getPeer();
    if (peer === undefined) {
        throw new Error('peer has not been set yet');
    }
    peer.on('open', ()=>{
        worldViewerWindow.hel_skyway_join();
        worldViewerWindow.hel_skyway_display_room_video();
    });
};
/**
 * @remarks
 * g_MultiPlay(XRWorldIngame, JRWorld_web）経由で
 * multiPlayの場合に参照
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 *
 * heliodor_front.jsから参照されるためglobal関数
 * @param configKey
 * @virtual
 */ worldViewerWindow.hel_skyway_main = async (configKey)=>{
    // TODO 暫定的に残す
    await worldViewerWindow.initializePeer();
    // TODO 暫定的に残す
    worldViewerWindow.joinViaPeer();
};
/**
 * @remarks
 * JRWorld_webから呼出あり。
 * heliodor_front.jsから呼び出されるためglobal関数化
 * @param method
 * @param url
 * @param option
 */ worldViewerWindow.apiAjax = (method, url, option)=>{
    const api_url = SKYWAY_API_HOST + url;
    // 明示的にnullを送るケースあり
    const payload = option.data === undefined ? null : option.data;
    const ajax = new XMLHttpRequest();
    ajax.open(method, api_url);
    ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    ajax.send(JSON.stringify(payload));
    ajax.addEventListener('load', function(e) {
        try {
            if (e.target === null || e.target === undefined || !('response' in e.target)) {
                return;
            }
            const response = JSON.parse(e.target['response']);
            if (e.target['status'] == 200) {
                if (option.done !== undefined) {
                    option.done(response);
                }
            } else {
                if (option.error !== undefined) {
                    option.error(response);
                }
            }
        } catch (error) {
            debugLog(error);
        }
    }, false);
};
/**
 * @remarks
 * heliodor_room.jsから移植
 * TODO アプリケーション層より
 * @param world_id
 * @param option
 */ worldViewerWindow.getRandomRoom = (world_id, option)=>{
    if (!world_id) {
        return;
    }
    worldViewerWindow.apiAjax('GET', '/rooms/random/' + world_id, {
        done: option === undefined ? undefined : option.done,
        error: option === undefined ? undefined : option.error
    });
};
/**
 * @remarks
 * heliodor_room.jsから移植
 * TODO アプリケーション層より
 * @param world_id
 * @param option
 */ worldViewerWindow.createNewRoom = (world_id, option)=>{
    if (!world_id) {
        return;
    }
    worldViewerWindow.apiAjax('POST', '/rooms', {
        data: {
            world_id: world_id
        },
        done: option === undefined ? undefined : option.done,
        error: option === undefined ? undefined : option.error
    });
};
/**
 * @remarks
 * heliodor_room.jsから移植
 * TODO アプリケーション層より
 * @param room_id
 * @param player_count
 * @param option
 */ worldViewerWindow.sendHeartbeat = (room_id, player_count, option)=>{
    if (!room_id || !player_count) {
        return;
    }
    worldViewerWindow.apiAjax('POST', '/rooms/' + room_id + '/heartbeat', {
        data: {
            player_count: player_count
        },
        done: option === undefined ? undefined : option.done,
        error: option === undefined ? undefined : option.error
    });
};
// Replace ":" to "&colon\;"
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param text
 */ worldViewerWindow.hel_skyway_to_code_colon = (text)=>text.replace(':', '&colon;')
;
// Recovery "&colon;" to ":"
/**
 * heliodor_skyway_rcp, heliodor_skyway_xrwから参照があるためglobal関数
 * @param text
 */ worldViewerWindow.hel_skyway_to_char_colon = (text)=>text.replace('&colon;', ':')
;
worldViewerWindow.hel_skyway_main_with_display_media = async ()=>{
    const localVideo = document.getElementById('js-local-stream');
    // const remoteVideos = document.getElementById('js-remote-streams') as HTMLVideoElement;
    //
    // const sdkSrc = document.querySelector('script[src*=skyway]');
    if (!navigator.mediaDevices) {
        debugLog('navigator.mediaDevices not found');
        return;
    }
    const localAudioStream = await setLocalAudioStreamBy();
    const localVideoStream = await navigator.mediaDevices.getDisplayMedia({
        audio: false,
        video: {
            width: {
                ideal: 1280
            },
            height: {
                ideal: 720
            },
            frameRate: {
                ideal: 30
            }
        }
    }).catch(console.error);
    localAudioStream.addTrack(localVideoStream.getVideoTracks()[0]);
    // default mic mute
    worldViewerWindow.hel_skyway_set_mic_state(false);
    // Render local stream
    localVideo.muted = true;
    localVideo.srcObject = localAudioStream;
    localVideo.playsInline = true;
    await localVideo.play().catch(console.error);
    // eslint-disable-next-line require-atomic-updates
    worldViewerWindow.g_peer = new Peer({
        key: worldViewerWindow.g_SKYWAY_KEY,
        debug: 0
    });
    worldViewerWindow.g_peer.on('error', console.error);
    worldViewerWindow.g_peer.on('open', ()=>{
        worldViewerWindow.hel_skyway_join();
        worldViewerWindow.hel_skyway_display_room_video();
    });
};
worldViewerWindow.hel_skyway_start_screen_sharing = async ()=>{
    if (!navigator.mediaDevices) {
        debugLog('navigator.mediaDevices not found');
        return;
    }
    const localVideoStream = await navigator.mediaDevices.getDisplayMedia({
        audio: true,
        video: {
            width: {
                ideal: 1280
            },
            height: {
                ideal: 720
            },
            frameRate: {
                ideal: 30
            }
        }
    }).catch(console.error);
    const localStream = worldViewerWindow.g_localStream;
    localVideoStream.getVideoTracks()[0].onended = function() {
        localStream.removeTrack(localVideoStream.getVideoTracks()[0]);
    };
    localStream.addTrack(localVideoStream.getVideoTracks()[0]);
    worldViewerWindow.hel_skyway_send_data('screenshare:shared');
    const room = worldViewerWindow.g_room;
    room.close();
    worldViewerWindow.hel_skyway_join();
    worldViewerWindow.g_Video.srcObject = localStream;
    worldViewerWindow.g_Video.playsInline = true;
};
worldViewerWindow.hel_skyway_display_room_video = ()=>{
    if (worldViewerWindow.g_room != null) {
        // const room = worldViewerWindow.g_room;
        // room.close();
        // worldViewerWindow.hel_skyway_join();
        worldViewerWindow.g_room.on('stream', (stream)=>{
            if (worldViewerWindow.g_Video != null) {
                if (worldViewerWindow.g_Video.srcObject !== stream) {
                    worldViewerWindow.g_Video.srcObject = stream;
                }
                worldViewerWindow.g_Video.playsInline = true;
            }
        });
    }
};
/**
 * @remarks
 * heliodor_xrw_mainから参照あり
 * @param configKey?
 * @returns {Peer|undefined}
 *
 */ worldViewerWindow.hel_skyway_generate_peer = async (configKey)=>worldViewerWindow.initializePeer(configKey)
;
// 即時実行
const cookie_Skyway_MyName = worldViewerWindow.hel_get_cookie('playername');
if (cookie_Skyway_MyName !== undefined) {
    setSkywayName(cookie_Skyway_MyName);
}
worldViewerWindow.hel_skyway_set_show_chatbox(false);
worldViewerWindow.hel_skyway_set_avatar_from_cookie();
